import { AdminTitle } from "@/pages/admin/AdminLayout";
import OfferingRecap from "@/pages/admin/OfferingRecap";

export default function Offerings() {
  return (
    <div data-testid="admin-offerings">
      <AdminTitle eyebrow="Keuangan" title="Hitung Persembahan" />
      <OfferingRecap />
    </div>
  );
}
